<app-banner></app-banner>
<div id="cbse">
    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12" id="school-image">
            <img src="/assets/img/about-school.jpg" alt="" class="img-fluid">
        </div>
    </div>

    <h1 class="display1 text-center"> Mandatory Public Disclosure</h1>
    <div class="container">
        <div class="row w-100">
            <div class="col-lg-12 col-md-12">
                <h4 class="text-warning font-weight-bold">A. GENERAL INFORMATION:</h4>
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th scope="col" style="width: 5%;">S.No.</th>
                            <th scope="col" style="width: 50%;">INFORMATION</th>
                            <th scope="col" style="width: 45%;">Details</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th>1</th>
                            <th> NAME OF THE SCHOOL</th>
                            <td>RAM PRASAD DAV PUBLIC SCHOOL</td>
                        </tr>
                        <tr>
                            <th>2</th>
                            <th>AFFILIATION NO. (IF APPLICABLE)</th>
                            <td>530251</td>
                        </tr>
                        <tr>
                            <th>3</th>
                            <th>SCHOOL CODE (IF APPLICABLE)</th>
                            <td>40235</td>
                        </tr>
                        <tr>
                            <th>4</th>
                            <th> COMPLETE ADDRESS WITH PIN CODE</th>
                            <td>RAM PRASAD DAV PUBLIC SCHOOL, LADWA ROAD, SHAHABAD MARKANDA, DISTT. KURUKSHETRA,
                                HARYANA, PIN- 136135</td>
                        </tr>
                        <tr>
                            <th>5</th>
                            <th>PRINCIPAL NAME & QUALIFICATION</th>
                            <td>DR. DEEPINDER WALIA, M.A. (Pol. Sci., History, Hindi, English, Education) B.ED, PHD.
                            </td>
                        </tr>
                        <tr>
                            <th>6</th>
                            <th>SCHOOL EMAIL ID</th>
                            <td>rpdavsbd@gmail.com</td>
                        </tr>
                        <tr>
                            <th>7</th>
                            <th>CONTACT DETAILS (LANDLINE/MOBILE)</th>
                            <td>+91 9416128500</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>


        <div class="row w-100">
            <div class="col-lg-12 col-md-12">
                <h4 class="text-warning font-weight-bold">B. DOCUMENTS AND INFORMATION:</h4>
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th scope="col" style="width: 5%;">S.No.</th>
                            <th scope="col" style="width: 80%;">INFORMATION</th>
                            <th scope="col" style="width: 15%;">Download</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th>1</th>
                            <th> COPIES OF AFFILIATION/UPGRADATION LETTER AND RECENT EXTENSION OF AFFILIATION, IF ANY
                            </th>
                            <td style="font-size: 20px;"><a
                                    href="https://drive.google.com/file/d/1jtK4kyokRBfxxfndHt6mTTRataU18KLz/view?usp=sharing"
                                    class="text-danger" download target="_blank"><i class="fa fa-cloud-download"
                                        aria-hidden="true"></i>
                                </a></td>
                        </tr>
                        <tr>
                            <th>2</th>
                            <th> COPIES OF SOCIETIES/TRUST/COMPANY REGISTRATION/RENEWAL CERTIFICATE, AS APPLICABLE</th>
                            <td style="font-size: 20px;"><a
                                    href="https://drive.google.com/file/d/1tn75CRWPNSnJUX5wtCx6G92HYKCn08Ak/view?usp=sharing"
                                    class="text-danger" download target="_blank"><i class="fa fa-cloud-download"
                                        aria-hidden="true"></i>
                                </a></td>
                        </tr>
                        <tr>
                            <th>3</th>
                            <th>COPY OF NO OBJECTION CERTIFICATE (NOC) ISSUED, IF APPLICABLE, BY THE STATE GOVT./UT</th>
                            <td style="font-size: 20px;"><a
                                    href="https://drive.google.com/file/d/1ITsNTPoYmENhv2SOA_lf1VDVsE7O_D5v/view?usp=sharing"
                                    class="text-danger" download target="_blank"><i class="fa fa-cloud-download"
                                        aria-hidden="true"></i>
                                </a></td>
                        </tr>
                        <tr>
                            <th>4</th>
                            <th>COPIES OF RECOGNITION CERTIFICATE UNDER RTE ACT. 2009, AND IT'S RENEWAL IF APPLICABLE
                            </th>
                            <td style="font-size: 20px;"><a
                                    href="https://drive.google.com/file/d/1HuGMraTv_yBpeKoMK4Zo7mVSy56AW48o/view?usp=sharing"
                                    class="text-danger" download target="_blank"><i class="fa fa-cloud-download"
                                        aria-hidden="true"></i>
                                </a></td>
                        </tr>
                        <tr>
                            <th>5</th>
                            <th>COPY OF VALID BUILDING SAFETY CERTIFICATE AS PER THE NATIONAL BUILDING CODE</th>
                            <td style="font-size: 20px;"><a
                                    href="https://drive.google.com/file/d/1_aSCyYjnpJb_hFeurHaWk9C6WvBX2zAM/view?usp=sharing"
                                    class="text-danger" download target="_blank"><i class="fa fa-cloud-download"
                                        aria-hidden="true"></i>
                                </a></td>
                        </tr>
                        <tr>
                            <th>6</th>
                            <th>COPY OF VALID FIRE SAFETY CERTIFICATE ISSUED BY THE COMPETENT AUTHORITY</th>
                            <td style="font-size: 20px;"><a
                                    href="https://drive.google.com/file/d/13lrudBZYVg0olXoW6ADi_2XY0QxiUkXi/view?usp=sharing"
                                    class="text-danger" download target="_blank"><i class="fa fa-cloud-download"
                                        aria-hidden="true"></i>
                                </a></td>
                        </tr>
                        <tr>
                            <th>7</th>
                            <th>COPY OF THE DEO CERTIFICATE SUBMITTED BY THE SCHOOL FOR
                                AFFILIATION/UPGRADATION/EXTENSION OF AFFILIATION OR SELF CERTIFICATION BY SCHOOL</th>
                            <td style="font-size: 20px;"><a
                                    href="https://drive.google.com/file/d/1BeF0EUgj-fnjRYzQV3bX1Cry81ip551u/view?usp=sharing"
                                    class="text-danger" download target="_blank"><i class="fa fa-cloud-download"
                                        aria-hidden="true"></i>
                                </a></td>
                        </tr>
                        <tr>
                            <th>8</th>
                            <th>COPIES OF VALID WATER, HEALTH AND SANITATION CERTIFICATES</th>
                            <td style="font-size: 20px;"><a
                                    href="https://drive.google.com/file/d/1XeZfaM7dMawZyxVEcktzOYa-angLsHox/view?usp=sharing"
                                    class="text-danger" download target="_blank"><i class="fa fa-cloud-download"
                                        aria-hidden="true"></i>
                                </a></td>
                        </tr>
                        <tr>
                            <th>9</th>
                            <th style="text-transform: uppercase;">APPENDIX -IX MANDATORY PUBLIC DISCLOSURE</th>
                            <td style="font-size: 20px;"><a
                                    href="https://drive.google.com/file/d/1BqkUdxX3pOD78gvw-dCvA0DymHvgWfyF/view?usp=sharing"
                                    class="text-danger" download target="_blank"><i class="fa fa-cloud-download"
                                        aria-hidden="true"></i>
                                </a></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="row w-100">
            <div class="col-lg-12 col-md-12">
                <h4 class="text-warning font-weight-bold">C. RESULT AND ACADEMICS:</h4>
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th scope="col" style="width: 5%;">S.No.</th>
                            <th scope="col" style="width: 80%;">INFORMATION</th>
                            <th scope="col" style="width: 15%;">Download</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th>1</th>
                            <th>FEE STRUCTURE OF THE SCHOOL</th>
                            <td style="font-size: 20px;"><a
                                    href="https://drive.google.com/file/d/1Y6XI4CFwDITQxdl9v8sYIN3q5lFNwUSW/view?usp=sharing"
                                    class="text-danger" download target="_blank"><i class="fa fa-cloud-download"
                                        aria-hidden="true"></i>
                                </a></td>
                        </tr>
                        <tr>
                            <th>2</th>
                            <th> ANNUAL ACADEMIC CALANDER 2026-27</th>
                            <td style="font-size: 20px;"><a
                                    href="/assets/pdf/Academic Calander 2026-27.pdf"
                                    class="text-danger" download target="_blank"><i class="fa fa-cloud-download"
                                        aria-hidden="true"></i>
                                </a></td>
                        </tr>
                        <tr>
                            <th>3</th>
                            <th> LIST OF SCHOOL MANAGEMENT COMMITTEE (SMC)</th>
                            <td style="font-size: 20px;"><a
                                    href="https://drive.google.com/file/d/1x-wPtDiQN8JzArO-WpGVHqp9IbSUAi_r/view?usp=sharing"
                                    class="text-danger" download target="_blank"><i class="fa fa-cloud-download"
                                        aria-hidden="true"></i>
                                </a></td>
                        </tr>
                        <tr>
                            <th>4</th>
                            <th> LIST OF PARENTS TEACHERS ASSOCIATION (PTA) MEMBERS</th>
                            <td style="font-size: 20px;"><a
                                    href="https://drive.google.com/file/d/1D8BEe3EUFaycp201e3Ir9CMLZ6rSlE7E/view?usp=sharing"
                                    class="text-danger" download target="_blank"><i class="fa fa-cloud-download"
                                        aria-hidden="true"></i>
                                </a></td>
                        </tr>
                        <tr>
                            <th>5</th>
                            <th>LIST OF TEACHERS QUALIFICATION & DESIGNATION</th>
                            <td style="font-size: 20px;"><a
                                    href="/assets/pdf/Teacher Qualification & Designation.pdf"
                                    class="text-danger" download target="_blank"><i class="fa fa-cloud-download"
                                        aria-hidden="true"></i>
                                </a></td>
                        </tr>
                        <tr>
                            <th>6</th>
                            <th>LIST OF HOLIDAYS 2026-27</th>
                            <td style="font-size: 20px;"><a
                                    href="/assets/pdf/List of Holidays 2026-27.pdf"
                                    class="text-danger" download target="_blank"><i class="fa fa-cloud-download"
                                        aria-hidden="true"></i>
                                </a></td>
                        </tr>
                        <tr>
                            <th>7</th>
                            <th> LAST THREE-YEAR RESULT OF THE BOARD EXAMINATION AS PER APPLICABILITY</th>
                            <td style="font-size: 20px;"><a
                                    href="https://drive.google.com/file/d/1Ms6DNiVpbb0oyMA7vYNP9SBqTnSltGTQ/view?usp=sharing"
                                    class="text-danger" download target="_blank"><i class="fa fa-cloud-download"
                                        aria-hidden="true"></i>
                                </a></td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </div>

        <div class="row w-100">
            <div class="col-lg-12 col-md-12">
                <h4 class="text-warning font-weight-bold">RESULT CLASS: X</h4>
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th scope="col" style="width: 5%;">S.No.</th>
                            <th scope="col">YEAR</th>
                            <th scope="col">NO. OF REGISTERED STUDENTS</th>
                            <th scope="col">NO. OF STUDENTS PASSED</th>
                            <th scope="col">PASS PERCENTAGE</th>
                            <th scope="col">REMARKS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th>1</th>
                            <td>2024-25</td>
                            <td>85</td>
                            <td>83</td>
                            <td>97%</td>
                            <td></td>
                        </tr>
                        <tr>
                            <th>2</th>
                            <td>2023-24</td>
                            <td>93</td>
                            <td>91</td>
                            <td>97%</td>
                            <td></td>
                        </tr>
                        <tr>
                            <th>3</th>
                            <td>2022-23</td>
                            <td>98</td>
                            <td>95</td>
                            <td>96.93%</td>
                            <td></td>
                        </tr>
                        <tr>
                            <th>4</th>
                            <td>2021-22</td>
                            <td>88</td>
                            <td>87</td>
                            <td>98.86%</td>
                            <td></td>
                        </tr>
                        <tr>
                            <th>5</th>
                            <td>2020-21</td>
                            <td>97</td>
                            <td>97</td>
                            <td>100%</td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="row w-100">
            <div class="col-lg-12 col-md-12">
                <h4 class="text-warning font-weight-bold">RESULT CLASS: XII</h4>
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th scope="col" style="width: 5%;">S.No.</th>
                            <th scope="col">YEAR</th>
                            <th scope="col">NO. OF REGISTERED STUDENTS</th>
                            <th scope="col">NO. OF STUDENTS PASSED</th>
                            <th scope="col">PASS PERCENTAGE</th>
                            <th scope="col">REMARKS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th>1</th>
                            <td>2024-25</td>
                            <td>157</td>
                            <td>153</td>
                            <td>97%</td>
                            <td></td>
                        </tr>
                        <tr>
                            <th>2</th>
                            <td>2023-24</td>
                            <td>110</td>
                            <td>109</td>
                            <td>98%</td>
                            <td></td>
                        </tr>
                        <tr>
                            <th>3</th>
                            <td>2022-23</td>
                            <td>95</td>
                            <td>92</td>
                            <td>96.84%</td>
                            <td></td>
                        </tr>
                        <tr>
                            <th>4</th>
                            <td>2021-22</td>
                            <td>99</td>
                            <td>89</td>
                            <td>89.9%</td>
                            <td></td>
                        </tr>
                        <tr>
                            <th>5</th>
                            <td>2020-21</td>
                            <td>126</td>
                            <td>126</td>
                            <td>100%</td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="row w-100">
            <div class="col-lg-12 col-md-12">
                <h4 class="text-warning font-weight-bold">D. STAFF (TEACHING):</h4>
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th scope="col" style="width: 5%;">S.No.</th>
                            <th scope="col" style="width: 50%;">INFORMATION</th>
                            <th scope="col" style="width: 45%;">Details</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th>1</th>
                            <th>PRINCIPAL</th>
                            <td>Dr. DEEPINDER WALIA</td>
                        </tr>
                        <tr>
                            <th rowspan="4" class="align-middle">2</th>
                            <th> TOTAL NO. OF TEACHERS</th>
                            <td>57</td>
                        </tr>
                        <tr>

                            <th> PGT</th>
                            <td>13</td>
                        </tr>
                        <tr>

                            <th> TGT</th>
                            <td>19</td>
                        </tr>
                        <tr>

                            <th>PRT</th>
                            <td>25</td>
                        </tr>
                        <tr>
                            <th>3</th>
                            <th> TEACHERS SECTION RATIO</th>
                            <td>1:2.1</td>
                        </tr>
                        <tr>
                            <th>4</th>
                            <th> DETAILS OF SPECIAL EDUCATOR</th>
                            <td>NO</td>
                        </tr>
                        <tr>
                            <th>5</th>
                            <th> DETAILS OF COUNSELLOR AND WELNESS TEACHER</th>
                            <td>NO</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="row w-100">
            <div class="col-lg-12 col-md-12">
                <h4 class="text-warning font-weight-bold">E. SCHOOL INFRASTRUCTURE:</h4>
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th scope="col" style="width: 5%;">S.No.</th>
                            <th scope="col" style="width: 50%;">INFORMATION</th>
                            <th scope="col" style="width: 45%;">Details</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th>1</th>
                            <th>TOTAL CAMPUS AREA OF THE SCHOOL (IN SQUARE MTR)</th>
                            <td>22257.71</td>
                        </tr>
                        <tr>
                            <th>2</th>
                            <th>NO. AND SIZE OF THE CLASSROOMS (IN SQ FT MTR)</th>
                            <td>20 Rooms(58) AND 21 Rooms(48.77)</td>
                        </tr>
                        <tr>
                            <th>3</th>
                            <th> NO. AND SIZE OF LABORATORIES INCLUDING COMPUTER LABS (IN SQ MTR)</th>
                            <td> 5 lab (60)</td>
                        </tr>
                        <tr>
                            <th>4</th>
                            <th> INTERNET FACILITY (Y/N)</th>
                            <td>Yes</td>
                        </tr>
                        <tr>
                            <th>5</th>
                            <th> NO. OF GIRLS TOILETS</th>
                            <td>26</td>
                        </tr>
                        <tr>
                            <th>6</th>
                            <th> NO. OF BOYS TOILETS</th>
                            <td>13</td>
                        </tr>
                        <tr>
                            <th>7</th>
                            <th>LINK OF YOUTUBE VIDEO OF THE INSPECTION OF SCHOOL COVERING THE INFRASTRUCTURE OF THE
                                SCHOOL</th>
                            <td style="font-size: 20px;"><a href="https://www.youtube.com/watch?v=Ha90WrRFFsQ&t=272s"
                                    class="text-danger" target="_blank"><i class="fas fa-eye"></i>
                                </a></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="row w-100">
            <div class="col-lg-12 col-md-12">
                <h4 class="text-warning font-weight-bold">F. Other Information:</h4>
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th scope="col" style="width: 5%;">S.No.</th>
                            <th scope="col" style="width: 80%;">INFORMATION</th>
                            <th scope="col" style="width: 15%;">Download</th>
                        </tr>
                    </thead>
                    <tbody>
                        <!-- <tr>
                            <th>1</th>
                            <th>NORMS FOR FIXING FEE</th>
                            <td style="font-size: 20px;" ><a href=""  download target="_blank"><i class="fa fa-cloud-download" aria-hidden="true"></i>
                            </a></td>
                        </tr>
                        <tr>
                            <th>2</th>
                            <th>NO. OF STUDENTS CLASS WISE</th>
                            <td style="font-size: 20px;" ><a href=""  download target="_blank"><i class="fa fa-cloud-download" aria-hidden="true"></i>
                            </a></td>
                        </tr> -->
                        <tr>
                            <th>1</th>
                            <th>ANNUAL REPORT</th>
                            <td style="font-size: 20px;"><a
                                    href="https://drive.google.com/file/d/1gEimqAR7jbmn4P6sqyiFsZYOI3XKz3Ce/view?usp=share_link"
                                    class="text-danger" download target="_blank"><i class="fa fa-cloud-download"
                                        aria-hidden="true"></i>
                                </a></td>
                        </tr>
                        <tr>
                            <th>2</th>
                            <th>TEACHERS TRAINING</th>
                            <td style="font-size: 20px;"><a
                                    href="https://drive.google.com/file/d/1wGAYKVWsxYYKYAnLZFG19e1HJOWAYcrO/view?usp=share_link"
                                    class="text-danger" download target="_blank"><i class="fa fa-cloud-download"
                                        aria-hidden="true"></i>
                                </a></td>
                        </tr>
                        <tr>
                            <th>3</th>
                            <th>LIST OF BOOKS</th>
                            <td style="font-size: 20px;"><a
                                    href="https://drive.google.com/file/d/1wNUKPKO9ul6JZOft0_XsQEL20dYoHzOD/view?usp=share_link"
                                    class="text-danger" download target="_blank"><i class="fa fa-cloud-download"
                                        aria-hidden="true"></i>
                                </a></td>
                        </tr>
                        <tr>
                            <th>4</th>
                            <th>SCHOOL LEAVING CERTIFICATE</th>
                            <td style="font-size: 20px;"><a
                                    href="https://drive.google.com/file/d/1kJCPGnVOQKbbeJVtcXpEta1JkYuamPmj/view?usp=share_link"
                                    class="text-danger" download target="_blank"><i class="fa fa-cloud-download"
                                        aria-hidden="true"></i>
                                </a></td>
                        </tr>
                        <tr>
                            <th>5</th>
                            <th>LINK OF CURRICULUM</th>
                            <td style="font-size: 20px;"><a href="https://cbseacademic.nic.in//curriculum_2024.html"
                                    class="text-danger" target="_blank"><i class="fas fa-eye"></i>
                                </a></td>
                        </tr>
                        <!-- <tr>
                            <th>4</th>
                            <th>SELF AFFIDAVIT</th>
                            <td style="font-size: 20px;" ><a href=""  download target="_blank"><i class="fa fa-cloud-download" aria-hidden="true"></i>
                            </a></td>
                        </tr>
                        <tr>
                            <th>7</th>
                            <th>DETAILS OF TEACHERS INCLUDING QUALIFICATIONS</th>
                            <td style="font-size: 20px;" ><a href=""  download target="_blank"><i class="fa fa-cloud-download" aria-hidden="true"></i>
                            </a></td>
                        </tr> -->

                    </tbody>
                </table>
            </div>
        </div>


    </div>
</div>